var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('el-result',{staticStyle:{"width":"100%"},attrs:{"icon":"success","title":"同步"}},[_c('div',{staticStyle:{"line-height":"1.5","color":"#999"},attrs:{"slot":"subTitle"},slot:"subTitle"},[_vm._v(" 身份同步成功"),_c('br'),_vm._v("稍后将返回至应用首页 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }